/* LumaVeil sticky add-to-cart bar.
   Shows after the main add-to-cart button scrolls out of view and clicks that button, so variant and quantity stay in sync. */
(function () {
  var bar = document.querySelector('[data-lv-sticky]');
  var mainBtn = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!bar || !mainBtn) return;

  var barBtn = bar.querySelector('[data-lv-sticky-button]');
  var barPrice = bar.querySelector('[data-lv-sticky-price]');

  function syncPrice() {
    var src = document.querySelector('.product__info-container .price .price-item--last');
    if (src && barPrice) barPrice.textContent = src.textContent.trim();
  }

  function syncButton() {
    var label = mainBtn.querySelector('span');
    if (label && label.textContent.trim()) barBtn.textContent = label.textContent.trim();
    barBtn.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
  }

  function setVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    barBtn.tabIndex = visible ? 0 : -1;
    document.body.classList.toggle('lv-has-sticky', visible);
    if (visible) {
      syncPrice();
      syncButton();
    }
  }

  barBtn.addEventListener('click', function () {
    if (!mainBtn.disabled) mainBtn.click();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainBtn);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.setTimeout(function () {
        syncPrice();
        syncButton();
      }, 300);
    });
  }

  syncPrice();
  syncButton();
})();
